import Constants from 'expo-constants'

/**
 * Optional label for a build that is not a release — set at bundle time by
 * `scripts/ios-device-build.sh` (EXPO_PUBLIC_BUILD_LABEL=test). It is appended
 * to the version everywhere we show or report it, so a local test build on a
 * phone can never be mistaken for the shipped one.
 */
export const BUILD_LABEL = process.env.EXPO_PUBLIC_BUILD_LABEL?.trim() || undefined

/** "0.9.708", or "0.9.708 (test)" on a labelled build. */
export function formatAppVersion(version: string | undefined, label: string | undefined): string | undefined {
  if (!version) return undefined
  return label ? `${version} (${label})` : version
}

// Single source of truth: app.json's expo.version (the release version). Bump
// it there and this — plus the GitHub release tag — all move together.
// Visual-regression fixture builds show a fixed value instead: every PR bumps
// the version, which would otherwise invalidate the About screenshots each time.
export const APP_VERSION = process.env.EXPO_PUBLIC_VISUAL_FIXTURES === '1'
  ? '0.0.0-visual'
  : formatAppVersion(Constants.expoConfig?.version, BUILD_LABEL) ?? '0.0.0'
